import React, { useCallback, useEffect, useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
export const TrainingGalleryStrip = () => {
  const galleryItems = ['https://uploadthingy.s3.us-west-1.amazonaws.com/fUrvThWdJVSVsYbHQSSyQ8/SAV_8518.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/62DL8VzUWoZSsys88qcCmf/speaking_anne.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/9ciCFjhcNKhhvWPuNF4wxL/Network_Scoot.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/mStosbmgsDJZaVNXWK79Vp/IMG-20241230-WA0235.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/vqYAu12xeCB8m1eJ25tfZh/SAV_8332.jpg'];
  const [currentIndex, setCurrentIndex] = useState(0);
  const [visibleCount, setVisibleCount] = useState(3);
  // Handle responsive visible count
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) setVisibleCount(1);else if (window.innerWidth < 1024) setVisibleCount(2);else setVisibleCount(3);
    };
    // Initial check
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  const maxIndex = Math.max(0, galleryItems.length - visibleCount);
  const nextSlide = useCallback(() => {
    setCurrentIndex(prev => prev >= maxIndex ? 0 : prev + 1);
  }, [maxIndex]);
  const prevSlide = () => {
    setCurrentIndex(prev => prev <= 0 ? maxIndex : prev - 1);
  };
  // Auto-play interval
  useEffect(() => {
    const timer = setInterval(nextSlide, 4000);
    return () => clearInterval(timer);
  }, [nextSlide]);
  return <section className="py-16 bg-white border-b border-gray-100 overflow-hidden" data-id="element-1154">
      <div className="container mx-auto px-4 mb-10" data-id="element-1155">
        <div className="text-center scroll-animate" data-id="element-1156">
          <h2 className="text-3xl md:text-4xl font-bold text-navy mb-3 font-heading" data-id="element-1157">
            Training and Networking in Action
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-1158">
            See our hands-on sessions across Nigeria
          </p>
        </div>
      </div>

      <div className="container mx-auto px-4 relative scroll-animate" style={{
      animationDelay: '200ms'
    }} data-id="element-1159">
        <div className="relative overflow-hidden group" data-id="element-1160">
          {/* Slider Track */}
          <div className="flex transition-transform duration-500 ease-in-out" style={{
          transform: `translateX(-${currentIndex * (100 / visibleCount)}%)`
        }} data-id="element-1161">
            {galleryItems.map((image, index) => <div key={index} className="flex-shrink-0 px-3" style={{
            width: `${100 / visibleCount}%`
          }} data-id="element-1162">
                <div className="relative h-[320px] md:h-[400px] rounded-xl overflow-hidden shadow-md" data-id="element-1163">
                  <img src={image} alt={`Training session ${index + 1}`} className="absolute inset-0 w-full h-full object-cover" data-id="element-1164" />
                </div>
              </div>)}
          </div>

          {/* Navigation Arrows */}
          <button onClick={prevSlide} className="absolute left-0 top-1/2 -translate-y-1/2 -ml-2 md:ml-2 bg-white/90 hover:bg-white text-navy p-2 rounded-full shadow-lg transition-all z-10 opacity-0 group-hover:opacity-100 disabled:opacity-0" disabled={currentIndex === 0} aria-label="Previous image" data-id="element-1165">
            <ChevronLeft size={24} data-id="element-1166" />
          </button>
          <button onClick={nextSlide} className="absolute right-0 top-1/2 -translate-y-1/2 -mr-2 md:mr-2 bg-white/90 hover:bg-white text-navy p-2 rounded-full shadow-lg transition-all z-10 opacity-0 group-hover:opacity-100 disabled:opacity-0" disabled={currentIndex === maxIndex} aria-label="Next image" data-id="element-1167">
            <ChevronRight size={24} data-id="element-1168" />
          </button>
        </div>

        {/* Dots */}
        <div className="flex justify-center gap-2 mt-8" data-id="element-1169">
          {Array.from({
          length: maxIndex + 1
        }).map((_, idx) => <button key={idx} onClick={() => setCurrentIndex(idx)} className={`w-2.5 h-2.5 rounded-full transition-all ${currentIndex === idx ? 'bg-navy w-6' : 'bg-gray-300 hover:bg-gray-400'}`} aria-label={`Go to slide group ${idx + 1}`} data-id="element-1170" />)}
        </div>
      </div>
    </section>;
};